/**
 * Action used to store jaas customer details
 */
export const SET_DETAILS = 'SET_DETAILS';
